/**
 * NotificationListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * NotificationListReq
 */
export interface NotificationListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 通知类型 */
  type?: string
  /** 投递类型 */
  delivery_type?: string
  /** 目标类型 */
  target_type?: string
  /** 接收者用户ID */
  recipient_user_id?: any
  /** 发送者用户ID */
  sender_id?: any
  /** 目标ID */
  target_id?: string
  /** 受众标识 */
  audience_key?: string
  /** 是否已读 */
  is_read?: boolean
  /** 是否已推送 */
  pushed?: boolean
  /** 通知类型列表 */
  type__in?: string[]
  /** 投递类型列表 */
  delivery_type__in?: string[]
  /** 目标类型列表 */
  target_type__in?: string[]
  /** 接收者用户ID列表 */
  recipient_user_id__in?: any
  /** 发送者用户ID列表 */
  sender_id__in?: any
  /** 标题包含 */
  title__like?: string
  /** 正文包含 */
  body__like?: string
  /** 推送时间距今(如:7d,1h,30m) */
  pushed_at__since?: any
  /** 推送时间早于(如:7d,1h,30m) */
  pushed_at__before?: any
  /** 阅读时间距今(如:7d,1h,30m) */
  read_at__since?: any
  /** 阅读时间早于(如:7d,1h,30m) */
  read_at__before?: any
}

/**
 * NotificationListReq Schema
 */
export const NotificationListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    type: {
      description: '通知类型',
      format: 'cons.NotificationType',
      type: 'string',
      label: '通知类型',
    },
    delivery_type: {
      description: '投递类型',
      format: 'cons.NotificationDeliveryType',
      type: 'string',
      label: '投递类型',
    },
    target_type: {
      description: '目标类型',
      format: 'cons.NotificationTargetType',
      type: 'string',
      label: '目标类型',
    },
    recipient_user_id: {
      description: '接收者用户ID',
      format: 'string',
      type: 'user',
      label: '接收者用户ID',
    },
    sender_id: {
      description: '发送者用户ID',
      format: 'string',
      type: 'user',
      label: '发送者用户ID',
    },
    target_id: {
      description: '目标ID',
      format: 'string',
      type: 'string',
      label: '目标ID',
    },
    audience_key: {
      description: '受众标识',
      format: 'string',
      type: 'string',
      label: '受众标识',
    },
    is_read: {
      description: '是否已读',
      format: '*bool',
      type: 'boolean',
      label: '是否已读',
    },
    pushed: {
      description: '是否已推送',
      format: '*bool',
      type: 'boolean',
      label: '是否已推送',
    },
    type__in: {
      description: '通知类型列表',
      format: '[]cons.NotificationType',
      items: {
        format: 'cons.NotificationType',
        type: 'string',
      },
      type: 'array',
      label: '通知类型列表',
    },
    delivery_type__in: {
      description: '投递类型列表',
      format: '[]cons.NotificationDeliveryType',
      items: {
        format: 'cons.NotificationDeliveryType',
        type: 'string',
      },
      type: 'array',
      label: '投递类型列表',
    },
    target_type__in: {
      description: '目标类型列表',
      format: '[]cons.NotificationTargetType',
      items: {
        format: 'cons.NotificationTargetType',
        type: 'string',
      },
      type: 'array',
      label: '目标类型列表',
    },
    recipient_user_id__in: {
      description: '接收者用户ID列表',
      format: '[]string',
      type: 'user',
      label: '接收者用户ID列表',
    },
    sender_id__in: {
      description: '发送者用户ID列表',
      format: '[]string',
      type: 'user',
      label: '发送者用户ID列表',
    },
    title__like: {
      description: '标题包含',
      format: 'string',
      type: 'string',
      label: '标题包含',
    },
    body__like: {
      description: '正文包含',
      format: 'string',
      type: 'string',
      label: '正文包含',
    },
    pushed_at__since: {
      description: '推送时间距今(如:7d,1h,30m)',
      format: '*string',
      type: 'datetime',
      label: '推送时间距今',
    },
    pushed_at__before: {
      description: '推送时间早于(如:7d,1h,30m)',
      format: '*string',
      type: 'datetime',
      label: '推送时间早于',
    },
    read_at__since: {
      description: '阅读时间距今(如:7d,1h,30m)',
      format: '*string',
      type: 'datetime',
      label: '阅读时间距今',
    },
    read_at__before: {
      description: '阅读时间早于(如:7d,1h,30m)',
      format: '*string',
      type: 'datetime',
      label: '阅读时间早于',
    },
  },
  type: 'object',
}
